import { ApiProperty } from "@nestjs/swagger";

export class TrimsRequset {
    @ApiProperty()
    brandId: number;
    @ApiProperty()
    packStyleId: number;
    @ApiProperty()
    variantId: number;
    @ApiProperty()
    endCustomerId: number;
    @ApiProperty()
    reqFrom?: string;
    @ApiProperty()
    itemId?: number;
    @ApiProperty()
    subcategoryId?: number;
    @ApiProperty()
    trimId: number;

}

export class TrimsItemRequest {
    @ApiProperty()
    trimId: number;
}

export class TrimItemIdReq {
    @ApiProperty()
    trimItemId: number
}